import {getRouteApi} from "@tanstack/react-router";

export const representativeContactsRouteApi = getRouteApi(
  "/_app/sales/representatives/$representativeId/contacts/",
);
